<template>
  <div>
    <portal-target name="closeX"></portal-target>
    <b-container class="banContainer">
      <b-img v-if="bValid === true"
             :style="{ cursor: bCursor }"
             :src="bImage"
             alt="Banner not displayed (yet)"
             @click="bClick"
             @mousemove="bHover"
             @mouseover="bEnter"
             @mouseleave="bLeave"
             @dblclick="bDblClick"
             class="image">
      </b-img>
      <portal to="closeX">
        <button id="close"
                @click="banClose">
                <div id="bInner">X</div>
        </button>
      </portal>
    </b-container>
  </div>
</template>

<script>
// eslint-disable-next-line
import utl from '../myUtils';
export default {
  watch: {
    mySecond() {
      this.intervalSecond();
    },
    myTenth() {
      this.intervalTenthSecond();
    },
  },
  computed: {
    winSize() {
      return this.$store.getters.getWinSize;
    },
    banners() {
      return this.$store.getters.getBanners;
    },
    signedIn() {
      return this.$store.getters.getSiStatus;
    },
    showBannerFlag() {
      return this.$store.getters.getShowBanner;
    },
    myTenth() {
      return this.$store.getters.getMyTenth;
    },
    mySecond() {
      return this.$store.getters.getMySecond;
    },
    fonts() {
      return this.$store.getters.getFonts;
    },
  },
  data() {
    return {
      bCursor: 'pointer',
      bSelected: false,
      slide: 0,
      sliding: null,
      bValid: false,
      bImage: '',
      increment: 40,
      bCount: 0,
      mOver: false,
      banDiag: false,
      activeZone: 0,
      zoneClickable: false,
      zoneURL: '',
    };
  },
  methods: {
    // eslint-disable-next-line
    bClick(event) {
      const zone = this.getZone(event);
      if (zone === 101) { // Clicked left edge of image - Go back to prior image
        this.priorImage();
        return;
      }
      if (zone === 102) { // Clicked right edge of image - Go to next image
        this.nextImage();
        return;
      }

      this.bSelected = true; // Prevent hover diag until we exit and enter the image again
      // this.diag('clicked zone');
      let msg = 'no zone selected';
      if (typeof this.banners[this.bCount][zone] !== 'undefined') {
        msg = `Selected Zone= ${String(zone)}`;
      } else {
        msg = `Zone ${String(zone)} is not allowed`;
      }
      if (this.banDiag) this.diag(msg);
      if (this.zoneClickable === true) {
        // this.diag(this.zoneURL);
        // window.open(this.zoneURL, '_blank');
        const newTab = window.open(); // [119]
        newTab.location.href = this.zoneURL; // [119]
        this.$store.commit('resetTime');
      } else {
        // this.diagClose();
      }
    },
    bDblClick() {
      this.writeDiag(`Title: ${this.banners[this.bCount].ttl}`);
      this.writeDiag(`Info: ${this.banners[this.bCount].info}`);
      this.writeDiag(`Image: ${this.banners[this.bCount].img}`);
    },
    priorImage() {
      if (this.bCount > 1) {
        this.bCount -= 1;
      } else {
        this.bCount = this.banners.count;
      }
      this.bImage = this.banners[this.bCount].img;
    },
    nextImage() {
      if (this.bCount < this.banners.count) {
        this.bCount += 1;
      } else {
        this.bCount = 1;
      }
      this.bImage = this.banners[this.bCount].img;
    },
    // eslint-disable-next-line
    bEnter(event) {
      this.mOver = true;
      this.bSelected = false;
    },
    // eslint-disable-next-line
    bLeave(event) {
      this.mOver = false;
      this.diagClose();
      // eslint-disable-next-line
      // const zone = this.getZone(event);
      if (this.activeZone > 0) {
        // utl.diag(`Exit Zone: ${this.activeZone}`);
        this.activeZone = 0;
      }
    },
    // eslint-disable-next-line
    bHover(event) {
      // eslint-disable-next-line
      const zone = this.getZone(event); // Need to do this so Pointer changes by zone
      if (zone !== this.activeZone) {
        if (this.activeZone > 0) {
          // utl.diag(`Exit Zone: ${this.activeZone}`);
        }
        // utl.diag(`Enter Zone: ${zone}`);
        this.activeZone = zone;
        if (typeof this.banners[this.bCount][zone] !== 'undefined') {
          this.zoneClickable = true;
          this.zoneURL = this.banners[this.bCount][zone];
        } else {
          this.zoneClickable = false;
          this.zoneURL = '';
        }
      }
    },
    // eslint-disable-next-line
    getZone(event) {
      const target = event.target || event.srcElement;
      if (this.banners.count > 1) {
        if (event.offsetX < 11) {
          this.bCursor = 'pointer';
          if (this.banDiag) this.diag('Click here to see PRIOR banner');
          return 101;
        }
        if ((target.clientWidth - event.offsetX) < 11) {
          this.bCursor = 'pointer';
          if (this.banDiag) this.diag('Click here to see NEXT banner');
          return 102;
        }
      }
      let left = false;
      let top = false;
      let zone = 0;
      let point = 'not-allowed';
      let clickable = 'Not Allowed';
      if (event.offsetX < (target.clientWidth / 2)) { left = true; }
      if (event.offsetY < (target.clientHeight / 2)) { top = true; }
      if ((left === true) && (top === true)) zone = 1;
      if ((left === true) && (top === false)) zone = 2;
      if ((left === false) && (top === true)) zone = 3;
      if ((left === false) && (top === false)) zone = 4;
      if (typeof this.banners[this.bCount][zone] !== 'undefined') {
        point = 'pointer';
        clickable = 'You can click here';
      } else {
        point = 'not-allowed';
        clickable = "Don't click here";
      }
      this.bCursor = point;
      if (this.bSelected === false) {
        if (this.banDiag) this.diag(clickable);
      }
      return zone;
    },
    banClose() {
      this.$store.commit('setShowBanner', false);
      // this.$emit('banClose');
    },
    diagClose() {
      this.$store.commit('hideDiag');
    },
    diag(msg) {
      this.$store.commit('showDiag', `Banner: ${msg}`);
    },
    writeDiag(message) {
      this.$store.commit('putDiag', message);
    },
    onSlideStart() {
      this.sliding = true;
    },
    onSlideEnd() {
      this.sliding = false;
    },
    intervalSecond() {
      if (this.showBannerFlag) {
        if (this.mOver) {
          this.increment = 0; // If Mouse is over Banner, reset counter
        } else {
          this.increment += 1; // If Mouse is NOT over Banner, count every 1/10 second
        }
        if (this.increment > 3) { // If 40 tenths (4 seconds) change banner
          if (this.bCount < this.banners.count) {
            this.bCount += 1;
          } else {
            this.bCount = 1;
          }
          this.bImage = this.banners[this.bCount].img;
          this.bValid = true;
          this.increment = 0;
          // this.diag(this.banners[this.bCount].info);
        }
      }
    },
    intervalTenthSecond() {
      if (this.showBannerFlag) {
        if (this.bValid !== true) {
          this.bCount = 1;
          this.bImage = this.banners[this.bCount].img;
          this.bValid = true;
          this.increment = 0;
          // this.diag(this.banners[this.bCount].info);
        }
      }
    },
  },
  beforeDestroy() {
    // clearInterval(this.intervalTenthSecond);
  },
  created() {
    // setInterval(() => this.intervalTenthSecond(), 100);
  },
};
</script>

<style scoped>
  .banContainer {
    position: relative;
    border: solid 1px black;
    margin: 0;
    padding: 0;
  }
  .image {
    position: relative;
    display: inline-flex;
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    /* cursor: pointer; */
    /* border: solid 1px blue; */
  }
  #close {
    position: absolute;
    width: 20px;
    height: 20px;
    background: red;
    top: 0px;
    right: 0px;
    cursor: pointer;
    z-index: 100;
  }
  #bInner {
    position: absolute;
    display: block;
    font-size: 18px;
    font-weight: bold;
    color: black;
    top: -4px;
    left: 2px;
  }
</style>



// WEBPACK FOOTER //
// src/components/z-banner.vue